import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getTextFieldDefaultProps } from '../../utils/TextFieldUtils';
import { CustomTextField } from './../CustomTextField';

class CustomNumberField extends Component {
  valueIsValid(value) {
    return /^([0-9]|\.|-)*$/g.test(value);
  }

  onlyIntegerIsValid(value) {
    if (!this.props.onlyInteger) {
      return true;
    }
    const arrValue = String(value).split('');
    let i;
    let total = arrValue.length;
    for (i = 0; i < total; ++i) {
      if (String(arrValue[i]) === '.') {
        return false;
      }
    }
    return true;
  }

  onlyPositiveIsValid(value) {
    if (!this.props.onlyPositive) {
      return true;
    }
    const arrValue = String(value).split('');
    let i;
    let total = arrValue.length;
    for (i = 0; i < total; ++i) {
      if (String(arrValue[i]) === '-') {
        return false;
      }
    }
    return true;
  }

  doubleValid(value) {
    let valido = value.includes('.');
    if (valido) {
      const splitValue = value.split('.');
      if (splitValue[1].length > 2) {
        return false;
      }
    }
    return true;
  }

  render() {
    let allProps = {
      color: 'secondary',
      ...getTextFieldDefaultProps(),
      ...this.props,
      type: 'number',
      onChange: (event) => {
        const value = String(event.target.value ?? '');
        if (this.props.maxLength && value.length > this.props.maxLength) {
          return;
        }
        if (this.props.max && parseInt(value) > this.props.max) return;
        if (
          this.valueIsValid(value) &&
          this.onlyIntegerIsValid(value) &&
          this.onlyPositiveIsValid(value) &&
          this.doubleValid(value)
        ) {
          if (typeof this.props.onChange === 'function') {
            this.props.onChange(event);
          }
        }
      },
    };
    delete allProps.onlyInteger;
    delete allProps.onlyPositive;
    return (
      <CustomTextField {...allProps}>{this.props.children}</CustomTextField>
    );
  }
}

CustomNumberField.propTypes = {
  ...CustomTextField.propTypes,
  onlyInteger: PropTypes.bool,
  onlyPositive: PropTypes.bool,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  error: PropTypes.string,
};

export default CustomNumberField;
